var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M12 15.571a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M6.893 5.628 5.03 5.513a.85.85 0 0 0-.646.238 9.6 9.6 0 0 0-2.353 3.907.75.75 0 0 0 .108.656l1.035 1.488v1.539L2.14 14.829a.76.76 0 0 0-.108.655 9.6 9.6 0 0 0 2.353 3.908.846.846 0 0 0 .646.238l1.862-.115 1.39.769.826 1.603a.8.8 0 0 0 .22.267.8.8 0 0 0 .318.15 10.5 10.5 0 0 0 4.706 0 .8.8 0 0 0 .317-.15.8.8 0 0 0 .22-.267l.828-1.603 1.39-.77 1.861.116a.85.85 0 0 0 .646-.238 9.6 9.6 0 0 0 2.353-3.908.75.75 0 0 0-.108-.655l-1.035-1.488v-1.539l1.035-1.488a.76.76 0 0 0 .108-.656 9.6 9.6 0 0 0-2.353-3.907.845.845 0 0 0-.646-.238l-1.862.115-1.39-.77-.826-1.603a.8.8 0 0 0-.22-.266.8.8 0 0 0-.318-.151 10.5 10.5 0 0 0-4.706 0 .8.8 0 0 0-.317.151.8.8 0 0 0-.22.266L8.281 4.86z"
  })));
};
export default SvgSettings;